




import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../lib/abpbase";

@Component({
  components: {}
})
export default class IntTimePicker extends AbpBase{

    @Prop({type:Number,default: null}) value: number;
    @Prop({ type:String, default: 'small'}) size: string;

    currentTime: string='';

    onChange(formatTime){
        let timeArr = formatTime.split(':');
        let m = parseInt(timeArr[0]) * 60 + parseInt(timeArr[1]);
        this.$emit('input',m);
        this.$emit('on-change');
    }
    @Watch("value")
    onValueChange(newVal,oldVal){
        let h = Math.floor(newVal / 60);
        let strH = h<10 ? '0' : '';
        let m = newVal % 60;
        let strM = m < 10 ? '0' : '';
        let strTime = strH + h + ":" + strM + m;
        if (strTime == this.currentTime) {
            return;
        }
        this.currentTime = strTime;
    }
}
